import { Brain, Heart, Sparkles, Target, Bot, BarChart } from "lucide-react";

const features = [
  {
    icon: Brain,
    title: "Captura Inteligente",
    description: "Jogue seus pensamentos aqui. Texto, voz ou foto. A IA organiza pra você.",
    color: "primary"
  },
  {
    icon: Heart,
    title: "Check-in Emocional",
    description: "Como você tá agora? Responda em 10 segundos. Receba dicas personalizadas.",
    color: "accent"
  },
  {
    icon: Sparkles,
    title: "Processamento Híbrido",
    description: "Decida o que fazer com suas ideias. Sozinho ou com ajuda da IA.",
    color: "primary"
  },
  {
    icon: Target,
    title: "Tarefas Adaptativas",
    description: "Tarefas que cabem no seu dia. Máximo 25 minutos cada. Sem sobrecarga.",
    color: "accent"
  },
  {
    icon: Bot,
    title: "Copiloto VYRA",
    description: "Uma IA que entende TDAH de verdade. Te acolhe antes de orientar.",
    color: "primary"
  },
  {
    icon: BarChart,
    title: "Insights Semanais",
    description: "Veja seus padrões. Celebre pequenas vitórias. Sem cobranças.",
    color: "accent"
  },
];

const FeatureShowcase = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-b from-background to-muted/20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Como funciona
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Tudo que você precisa para organizar sua mente, sem complicação.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => {
            // Classes precisam ser explícitas para Tailwind
            const iconBgClass = feature.color === 'primary' 
              ? 'bg-primary/10' 
              : 'bg-accent/10';
            const iconTextClass = feature.color === 'primary'
              ? 'text-primary'
              : 'text-accent';

            return (
              <div
                key={idx}
                className="bg-card p-6 rounded-xl border border-border shadow-[var(--shadow-soft)] hover:shadow-lg transition-[var(--transition-gentle)] space-y-4 group"
              >
                <div className={`w-12 h-12 rounded-lg ${iconBgClass} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                  <feature.icon className={`w-6 h-6 ${iconTextClass}`} />
                </div>
                <h3 className="text-lg font-semibold text-foreground">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureShowcase;
